"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var Card_1 = __importDefault(require("../Card"));
var sortTableData_1 = __importDefault(require("../../utils/sortTableData"));
var TableColumnMenu_1 = __importDefault(require("./TableColumnMenu"));
var filterTableData_1 = __importDefault(require("../../utils/filterTableData"));
var ColumnsMenu_1 = __importDefault(require("./ColumnsMenu"));
var tableSettings_1 = require("../../utils/tableSettings");
var CustomFilter_1 = __importDefault(require("./CustomFilter"));
var Pagination_1 = __importDefault(require("../../components/Pagination"));
var paginateTableData_1 = __importDefault(require("../../utils/paginateTableData"));
var DefaultEmptyStateMsg_1 = require("./DefaultEmptyStateMsg");
var LoadingAnimation_1 = __importDefault(require("../../components/LoadingAnimation"));
var Icon_1 = __importDefault(require("../../components/Icon"));
var classnames_1 = __importDefault(require("classnames"));
var Table = function (_a) {
    var columns = _a.columns, data = _a.data, title = _a.title, titleRightContent = _a.titleRightContent, customContent = _a.customContent, actions = _a.actions, selectable = _a.selectable, onSelect = _a.onSelect, onDataChange = _a.onDataChange, multi = _a.multi, _b = _a.rowsPerPage, rowsPerPage = _b === void 0 ? 10 : _b, includeSearch = _a.includeSearch, customFilters = _a.customFilters, customActions = _a.customActions, pagination = _a.pagination, backendOperations = _a.backendOperations, canSortColumns = _a.canSortColumns, defaultSortingColumn = _a.defaultSortingColumn, defaultSortingOrder = _a.defaultSortingOrder, tableId = _a.tableId, _c = _a.noDataMessage, noDataMessage = _c === void 0 ? react_1.default.createElement(DefaultEmptyStateMsg_1.DefaultEmptyStateMsg, null) : _c, _d = _a.loading, loading = _d === void 0 ? false : _d, _e = _a.loadingMessage, loadingMessage = _e === void 0 ? react_1.default.createElement(LoadingAnimation_1.default, null) : _e, totalElements = _a.totalElements, _f = _a.itemsPerPageChangeCallback, itemsPerPageChangeCallback = _f === void 0 ? function () { return null; } : _f, _g = _a.currentPageChangeCallback, currentPageChangeCallback = _g === void 0 ? function () { return null; } : _g, _h = _a.sortChangeCallback, sortChangeCallback = _h === void 0 ? function () { return null; } : _h, _j = _a.columnFiltersChangeCallback, columnFiltersChangeCallback = _j === void 0 ? function () { return null; } : _j, _k = _a.columnFiltersProp, columnFiltersProp = _k === void 0 ? {} : _k;
    var _l = __read((0, react_1.useState)(defaultSortingColumn || columns[0]), 2), sortingColumn = _l[0], setSortingColumn = _l[1];
    var _m = __read((0, react_1.useState)(defaultSortingOrder || 'asc'), 2), sortingOrder = _m[0], setSortingOrder = _m[1];
    var _o = __read((0, react_1.useState)((0, tableSettings_1.getInitialHiddenColumns)(tableId, columns)), 2), hiddenColumns = _o[0], setHiddenColumns = _o[1];
    var _p = __read((0, react_1.useState)((0, tableSettings_1.getInitialColumnFilters)(tableId, columns, data)), 2), columnFilters = _p[0], setColumnFilters = _p[1];
    var _q = __read((0, react_1.useState)((0, tableSettings_1.getInitialSortedColumns)(tableId, columns)), 2), sortedColumns = _q[0], setSortedColumns = _q[1];
    var _r = __read((0, react_1.useState)(1), 2), page = _r[0], setPage = _r[1];
    var _s = __read((0, react_1.useState)((0, tableSettings_1.getInitialRowsPerPage)(tableId, rowsPerPage)), 2), itemsPerPage = _s[0], setItemsPerPage = _s[1];
    var filteredData = (0, react_1.useMemo)(function () {
        // @ts-ignore
        return (0, filterTableData_1.default)(data, sortedColumns, columnFilters, customFilters);
    }, [data, sortedColumns, columnFilters, customFilters]);
    var orderedData = (0, react_1.useMemo)(function () {
        return (0, sortTableData_1.default)(filteredData, sortingColumn, sortingOrder);
    }, [filteredData, sortingColumn, sortingOrder]);
    (0, react_1.useEffect)(function () {
        if (!backendOperations && data.length) {
            setColumnFilters((0, tableSettings_1.getInitialColumnFilters)(tableId, columns, data));
        }
    }, [data, columns, tableId, backendOperations]);
    (0, react_1.useEffect)(function () {
        if (orderedData !== data) {
            onDataChange === null || onDataChange === void 0 ? void 0 : onDataChange(orderedData);
        }
    }, [orderedData, data, onDataChange]);
    (0, react_1.useEffect)(function () {
        itemsPerPageChangeCallback(itemsPerPage);
    }, [itemsPerPageChangeCallback, itemsPerPage]);
    var paginatedData = pagination ? (0, paginateTableData_1.default)(orderedData, page, itemsPerPage) : orderedData;
    var showColumnsMenu = canSortColumns || columns.some(function (c) { return c.canHide; });
    var showFilters = (customFilters === null || customFilters === void 0 ? void 0 : customFilters.length) > 0;
    var showToolbar = showColumnsMenu || showFilters || title || customContent;
    var alternativeContentToShow = function () {
        var fullTableCell = function (msg) { return (react_1.default.createElement("tr", null,
            react_1.default.createElement("td", { colSpan: sortedColumns.length },
                react_1.default.createElement("div", { className: "table-alternative-content-container" }, msg)))); };
        if (loading) {
            return fullTableCell(loadingMessage);
        }
        return fullTableCell(noDataMessage);
    };
    return (react_1.default.createElement(Card_1.default, { className: "ui-table" },
        showToolbar ? (react_1.default.createElement("div", { className: "ui-table-toolbar" },
            react_1.default.createElement("div", { className: "ui-table-toolbar-left" },
                react_1.default.createElement("div", { className: "ui-table-toolbar-left-title" },
                    title ? react_1.default.createElement("h2", null, title) : null,
                    titleRightContent ? react_1.default.createElement("div", { className: "ui-table-toolbar-left-title-right-content" }, titleRightContent) : null),
                customContent ? react_1.default.createElement("div", { className: "ui-table-toolbar-custom-content" }, customContent) : null,
                showFilters ? (customFilters.map(function (f, i) { return (react_1.default.createElement(CustomFilter_1.default, { key: i, filter: f })); })) : null),
            react_1.default.createElement("div", { className: "ui-table-toolbar-right" }, showColumnsMenu ? (react_1.default.createElement(ColumnsMenu_1.default, { disabled: loading, columns: sortedColumns, hiddenColumns: hiddenColumns, onHideOrShow: function (columnId, visible) {
                    setHiddenColumns(function (prev) {
                        if (visible) {
                            (0, tableSettings_1.saveHiddenColumns)(tableId, prev.filter(function (c) { return c !== columnId; }));
                            return prev.filter(function (c) { return c !== columnId; });
                        }
                        (0, tableSettings_1.saveHiddenColumns)(tableId, __spreadArray(__spreadArray([], __read(prev), false), [columnId], false));
                        return __spreadArray(__spreadArray([], __read(prev), false), [columnId], false);
                    });
                }, onSort: function (sortedOptions) {
                    setSortedColumns(function () {
                        var sorted = sortedOptions.map(function (o) { return sortedColumns.find(function (c) { return c.id === o.id; }); });
                        (0, tableSettings_1.saveSortedColumns)(tableId, sorted);
                        return sorted;
                    });
                }, canSortColumns: canSortColumns })) : null))) : null,
        react_1.default.createElement("div", { className: "ui-table-content ".concat(loading ? 'loading' : '') },
            loading && paginatedData.length > 0 ? (react_1.default.createElement("div", { className: "ui-table-loading-overlay" },
                react_1.default.createElement("div", { className: "ui-table-loading-overlay-content" }, loadingMessage))) : null,
            react_1.default.createElement("table", null,
                react_1.default.createElement("thead", null,
                    react_1.default.createElement("tr", null, sortedColumns.map(function (c) {
                        if (hiddenColumns.includes(c.id)) {
                            return null;
                        }
                        return (react_1.default.createElement("th", { key: c.id, style: { width: c.width, minWidth: c.minWidth } },
                            react_1.default.createElement("div", { className: "ui-table-header-cell" },
                                react_1.default.createElement("div", { className: "ui-table-header-cell-title" },
                                    sortingColumn === c && (react_1.default.createElement(Icon_1.default, { icon: "filter_list", className: (0, classnames_1.default)("ui-menu-item-icon-left", sortingOrder === "asc" ? "ui-table-header-cell-title-icon-rotate" : ""), size: "small" })),
                                    react_1.default.createElement("span", null, c.label)),
                                react_1.default.createElement(TableColumnMenu_1.default, { column: c, data: data, order: sortingOrder, disabled: loading, onSort: function (order) {
                                        if (backendOperations) {
                                            sortChangeCallback(c, order);
                                        }
                                        else {
                                            setSortingColumn(c);
                                            setSortingOrder(order);
                                        }
                                    }, onHide: function () {
                                        setHiddenColumns(__spreadArray(__spreadArray([], __read(hiddenColumns), false), [c.id], false));
                                    }, filters: backendOperations ? (columnFiltersProp[c.id] || []) : (columnFilters[c.id] || []), onFilter: function (columnIds) {
                                        var newFilters = backendOperations ? __assign({}, columnFiltersProp) : __assign({}, columnFilters);
                                        if (columnIds.length === 0) {
                                            delete newFilters[c.id];
                                        }
                                        else {
                                            newFilters[c.id] = columnIds;
                                        }
                                        if (backendOperations) {
                                            columnFiltersChangeCallback(newFilters);
                                        }
                                        else {
                                            setColumnFilters(newFilters);
                                            setPage(1);
                                        }
                                        (0, tableSettings_1.saveColumnFilters)(tableId, newFilters);
                                    }, backendOperations: backendOperations }))));
                    }))),
                react_1.default.createElement("tbody", null, paginatedData.length > 0 ? (paginatedData.map(function (d, i) { return (react_1.default.createElement("tr", { key: i }, sortedColumns.map(function (c) {
                    if (hiddenColumns.includes(c.id)) {
                        return null;
                    }
                    return (react_1.default.createElement("td", { key: c.id },
                        react_1.default.createElement("div", { className: "ui-table-cell" }, c.render ? c.render(d) : c.accessor(d))));
                }))); })) : alternativeContentToShow()))),
        pagination || backendOperations ? (react_1.default.createElement("div", { className: "ui-table-pagination" },
            react_1.default.createElement(Pagination_1.default, { page: page, disabled: loading, itemsPerPage: itemsPerPage, totalItems: backendOperations && totalElements ? totalElements : filteredData.length, showItemsPerPageSelector: true, onPageChange: function (p) {
                    if (backendOperations) {
                        currentPageChangeCallback(p);
                    }
                    setPage(p);
                }, onItemsPerPageChange: function (i) {
                    if (i === itemsPerPage)
                        return;
                    if (backendOperations) {
                        itemsPerPageChangeCallback(i);
                        currentPageChangeCallback(1);
                    }
                    setItemsPerPage(i);
                    setPage(1);
                    (0, tableSettings_1.saveRowsPerPage)(tableId, i);
                } }))) : null));
};
exports.default = Table;
